import React from 'react';
import Glob from "../../../libs/Glob.mjs";
import {
	Button, ButtonGroup,
	Form,
	Input,
	InputGroup,
	InputGroupText,
	Label,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader
} from "reactstrap";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import AppOkIcon from "../../../media/app-images/AppOkIcon.mjs";
import appLib from "../../../libs/appLib.mjs";
import AppSynthDataIcon from "../../../media/app-images/AppSynthDataIcon.mjs";
import AppPerimeterIcon from "../../../media/app-images/AppPerimeterIcon.mjs";
import UserIcon from "../../../media/images/UserIcon.mjs";
import AppLogIcon from "../../../media/app-images/AppLogIcon.mjs";
import FullScreenModal from "../../../controls/FullScreen/FullScreenModal.mjs";
import AppPalleIcon from "../../../media/app-images/AppPalleIcon.mjs";
import AppTrashIcon from "../../../media/app-images/AppTrashIcon.mjs";
import PeriGraphic from "../../../ComponentParts/Perimeters/PeriGraphic.mjs";


const prefix = 'PeriEditModal';

const PeriEditModal = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			data: structuredClone(props.peri),
			ll: Glob.getLanguageLong(),
			fullScreen: false,
		}
		this.uid = Glob.generateUid(prefix);
	}

	render() {
		const peri = this.state.data
		if ( this.state.fullScreen ) {
			return (
				<FullScreenModal
					title={ <>{ peri.fake ? <AppSynthDataIcon /> : <AppPerimeterIcon /> } <span>{ peri.name}</span></>}
					toggle={ ()=>{ this.setState({ fullScreen: false }) }}
				>
					<PeriGraphic
						id={this.state.data.id}
					/>
				</FullScreenModal>
			);
		}
		return (
			<Modal
				id={this.uid}
				className={prefix}
				isOpen={true}
				toggle={this.props.close}
				fade={false}
				onOpened={appLib.modalAutoFocus}
			>
				<ModalHeader toggle={this.props.close}>
					{ peri.fake ? <AppSynthDataIcon /> : <AppPerimeterIcon /> }
					{peri?.name}
				</ModalHeader>
				<Form
					autoComplete="off"
					onSubmit={(e) => {
						e.preventDefault();
						e.stopPropagation();
						this.props.save(this.state.data);
					}}
				>
					<ModalBody>
						<InputGroup>
							<InputGroupText>
								<UserIcon />
							</InputGroupText>
							<InputGroupText className={"flex-grow-1"}>
								{ this.state.data.created_by }
							</InputGroupText>
						</InputGroup>
						<InputGroup>
							<InputGroupText>
								<AppLogIcon />
							</InputGroupText>
							<InputGroupText className={"flex-grow-1"}>
								{ (new Date(this.state.data.creationDate)).toLocaleString(this.state.ll) }
							</InputGroupText>
						</InputGroup>
						<InputGroup>
							<InputGroupText>
								{ peri.fake ? <AppSynthDataIcon /> : <AppPerimeterIcon /> }
							</InputGroupText>
							<InputGroupText className={"flex-grow-1"}>
								{this.state.data.id}
							</InputGroupText>
						</InputGroup>
						<InputGroup className={"mt-4"}>
							<InputGroupText>
								<Label>
									<TextLabel value={"Name"}/>:
								</Label>
							</InputGroupText>
							<Input
								type="text"
								name="name"
								value={this.state.data.name || ''}
								onChange={e => {
									const d = this.state.data;
									d.name = e.target.value;
									this.setState({data: d});
								}}
							/>
						</InputGroup>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Description"}/>:
								</Label>
							</InputGroupText>
							<Input
								type="textarea"
								name="description"
								value={this.state.data.description || ''}
								onChange={e => {
									const d = this.state.data;
									d.description = e.target.value;
									this.setState({data: d});
								}}
							/>
						</InputGroup>
						{ (this.state.data.simulations && this.state.data.simulations.length > 0) && (
							<div>
								<hr />
								<h5>
									<TextLabel value={"Simulations"}/>: {this.state.data.simulations.length}
								</h5>
								<ul>
									{ this.state.data.simulations.map( (s,i) =>(
										<li key={i}>
											<span
												style={{ cursor: "pointer" }}
												onClick={() => { Glob.gotoPage({name: 'SimulationFlowEdit', params: {simul: s.id}})}}
											>
												{ s.name || s.description }
											</span>
										</li>
									))}
								</ul>
							</div>
						)}
					</ModalBody>
					<ModalFooter>
						<ButtonGroup className={"btn-icon"}>
							<Button
								onClick={ ()=>{ this.setState({ fullScreen: true }) }}
							>
								<i>
									<AppPalleIcon />
								</i>
								<b>
									<TextLabel value={"View"} />
								</b>
							</Button>
						</ButtonGroup>
						<ButtonGroup className={"btn-icon"}>
							<Button
								color={"danger"}
								hidden={ ! appLib.enabled() }
								onClick={ ()=>{
									if ( ! window.confirm( Glob.label('ConfirmCannotUndo'))) return;
									appLib.api('perimetri/remove', { id: peri.id }).then( ()=>{
										this.props.save();
									}).catch( err => {
										console.error( err );
									})
								}}
							>
								<i>
									<AppTrashIcon />
								</i>
								<b>
									<TextLabel value={"Delete"} />
								</b>
							</Button>
						</ButtonGroup>
						<ButtonGroup className={"btn-icon"}>
							<Button
								type="submit"
								color="primary"
								disabled={this.props.peri.description === this.state.data.description && this.props.peri.name === this.state.data.name}
							>
								<b>
									<TextLabel value={"Save"}/>
								</b>
								<i>
									<AppOkIcon/>
								</i>
							</Button>
						</ButtonGroup>
					</ModalFooter>
				</Form>
			</Modal>
		)
	}
}

export default PeriEditModal;
